import * as React from 'react'

// Components
import Form from 'common/components/form/new-form'
import DField from 'components/form/d-field'
import { TextInput } from 'components/form/text-input'
import { Modal } from 'components/modal'

// Modules
import { DI } from 'modules'

// Pages
import { AccountBlockFields } from 'pages/business/components/account-block'

const DownloadSliderSFTP = ({
  actions,
  common,
  company,
  onClose,
  onSuccess,
}) => {
  const { user } = actions
  const { strings } = common

  const rootCln = 'popup'

  const profilePrefix = 'page.profile.form'
  const sliderPrefix = 'page.video.slider'

  // State
  const [form, setFormState] = React.useState({ company })

  // Handlers
  const handleChange = React.useCallback(
    (event, form) => setFormState(form),
    []
  )

  const handleSubmit = React.useCallback(
    () => user.updateCompany(form.company).then(() => onSuccess()),
    [form, onSuccess, user]
  )

  return (
    <Modal onClose={onClose}>
      <div className={`${rootCln}-tip`}>
        <span className={`${rootCln}__title`}>
          {strings[`${sliderPrefix}.download.sftp_popup.title`]}
        </span>

        <Form onChange={handleChange}>
          <div className={`${rootCln}__tip`}>
            <AccountBlockFields>
              <DField label={strings[`${profilePrefix}.sftp_server`]}>
                <TextInput
                  isIP
                  isRequired
                  name="company[sftp_server]"
                  value={form.company.sftp_server}
                />
              </DField>

              <DField label={strings[`${profilePrefix}.sftp_username`]}>
                <TextInput
                  isRequired
                  name="company[sftp_username]"
                  value={form.company.sftp_username}
                />
              </DField>

              <DField label={strings[`${profilePrefix}.sftp_password`]}>
                <TextInput
                  isRequired
                  name="company[sftp_password]"
                  value={form.company.sftp_password}
                />
              </DField>
            </AccountBlockFields>
          </div>

          <div className={`${rootCln}-buttons`}>
            <div className={`${rootCln}-button`}>
              <button className="text-button" onClick={onClose} type="button">
                {strings[`${sliderPrefix}.download.sftp_popup.cancel`]}
              </button>
            </div>

            <div className={`${rootCln}-button`}>
              <button
                className="text-button"
                onClick={handleSubmit}
                type="button"
              >
                {strings[`${sliderPrefix}.download.sftp_popup.save`]}
              </button>
            </div>
          </div>
        </Form>
      </div>
    </Modal>
  )
}

export default DI(['common', 'user'])(DownloadSliderSFTP)
